(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-in-stock-modal"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('modal-content').then(() => {
    if (customElements.get('back-in-stock-modal')) return;

    const KLAVIYO_CLIENT_API = 'https://a.klaviyo.com/client';
    const KLAVIYO_REVISION = '2026-07-15';
    const ModalContent = customElements.get('modal-content');

    class BackInStockModal extends ModalContent {
      connectedCallback() {
        super.connectedCallback();
        this.form = this.querySelector('[data-back-in-stock-form]');
        this.submitButton = this.querySelector('[data-back-in-stock-submit]');
        this.errorMessage = this.querySelector('[data-back-in-stock-error]');
        this.successMessage = this.querySelector('[data-back-in-stock-success]');
        this.rootDelegate.on('click', '[data-back-in-stock-trigger]', this.onTriggerClick.bind(this));
        this.delegate.on('submit', '[data-back-in-stock-form]', this.onSubmit.bind(this));
      }

      attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'open' && !this.open) {
          document.documentElement.classList.toggle('lock-all', document.querySelector('.drawer[open]') !== null);
        }
      }

      onTriggerClick(event, trigger) {
        const variantId = trigger.form?.elements.namedItem('id')?.value;
        if (!variantId) return;

        event.preventDefault();
        this.variantId = variantId;
        this.form.reset();
        this.submitButton.hidden = false;
        this.errorMessage.hidden = true;
        this.successMessage.hidden = true;
        this.open = true;
      }

      async onSubmit(event) {
        event.preventDefault();
        const email = this.form.elements.namedItem('email').value.trim();
        const joinNewsletter = this.form.elements.namedItem('newsletter').checked;

        this.submitButton.disabled = true;
        this.errorMessage.hidden = true;
        this.successMessage.hidden = true;
        this.identify(email);

        try {
          await Promise.all([this.subscribeToVariant(email), joinNewsletter ? this.subscribeToList(email) : null]);
          this.submitButton.hidden = true;
          this.successMessage.hidden = false;
          this.successMessage.querySelector('[data-action="close"]').focus();
        } catch {
          this.errorMessage.hidden = false;
        } finally {
          this.submitButton.disabled = false;
        }
      }

      identify(email) {
        const klaviyo = window.klaviyo;
        const profile = { $email: email, $locale: this.getAttribute('locale') };
        if (klaviyo && typeof klaviyo.identify === 'function') {
          klaviyo.identify(profile);
        } else if (klaviyo && klaviyo.push) {
          klaviyo.push(['identify', profile]);
        }
      }

      subscribeToVariant(email) {
        return this.post('back-in-stock-subscriptions', {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.variantId}` } },
          },
        });
      }

      subscribeToList(email) {
        const listId = this.getAttribute('list-id');
        if (!listId) return null;

        return this.post('subscriptions', {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email, properties: { $source: 'Back in Stock' } } } },
          },
          relationships: {
            list: { data: { type: 'list', id: listId } },
          },
        });
      }

      async post(endpoint, data) {
        const companyId = encodeURIComponent(this.getAttribute('company-id'));
        const response = await fetch(`${KLAVIYO_CLIENT_API}/${endpoint}/?company_id=${companyId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
          body: JSON.stringify({ data }),
        });
        if (!response.ok) {
          throw new Error(`Klaviyo ${endpoint} request failed with status ${response.status}`);
        }
      }
    }

    customElements.define('back-in-stock-modal', BackInStockModal);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-category-chips"] && !Shopify.designMode) return;
  try {
    class CollectionCategoryChips extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-chips-list]');
      if (!this.list) return;
      this.storageKey = 'collection-category-chips:' + (this.dataset.scrollKey || '');
      this.onClick = this.onClick.bind(this);
      this.onInteract = this.onInteract.bind(this);
      this.settle = this.settle.bind(this);
      this.list.addEventListener('click', this.onClick);
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) => {
        this.list.addEventListener(type, this.onInteract, { passive: true });
      });
      this.restoreScroll();
      const active = this.list.querySelector('[aria-current]');
      if (active && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.settle);
        this.resizeObserver.observe(active);
        this.resizeObserver.observe(this.list);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.settle);
      if (document.readyState !== 'complete') window.addEventListener('load', this.settle, { once: true });
    }

    disconnectedCallback() {
      if (!this.list) return;
      this.list.removeEventListener('click', this.onClick);
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) => {
        this.list.removeEventListener(type, this.onInteract);
      });
      window.removeEventListener('load', this.settle);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    onInteract() {
      this.interacted = true;
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    settle() {
      if (this.interacted || !this.isConnected) return;
      this.restoreScroll();
    }

    restoreScroll() {
      const list = this.list;
      let saved = 0;
      try {
        saved = Number(window.sessionStorage.getItem(this.storageKey)) || 0;
      } catch (error) {
        saved = 0;
      }
      list.scrollLeft = saved;
      const active = list.querySelector('[aria-current]');
      if (!active) return;
      const margin = 16;
      const listBox = list.getBoundingClientRect();
      const chipBox = active.getBoundingClientRect();
      const chipStart = chipBox.left - listBox.left + list.scrollLeft;
      const chipEnd = chipStart + chipBox.width;
      if (chipEnd + margin > list.scrollLeft + list.clientWidth) {
        list.scrollLeft = chipEnd + margin - list.clientWidth;
      } else if (chipStart - margin < list.scrollLeft) {
        list.scrollLeft = Math.max(0, chipStart - margin);
      }
    }

    saveScroll() {
      try {
        window.sessionStorage.setItem(this.storageKey, String(Math.round(this.list.scrollLeft)));
      } catch (error) {
        return;
      }
    }

    onClick(event) {
      if (event.target.closest('a')) this.saveScroll();
    }
  }

  if (!customElements.get('collection-category-chips')) {
    customElements.define('collection-category-chips', CollectionCategoryChips);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-grid-video"] && !Shopify.designMode) return;
  try {
    class CollectionGridVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');
      if (!this.video) return;
      this.userPaused = false;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.video.controls = true;
        this.video.preload = 'metadata';
        this.loadSource();
        if (this.toggle) this.toggle.hidden = true;
        return;
      }
      this.onToggle = this.onToggle.bind(this);
      this.onPlaying = this.onPlaying.bind(this);
      if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
      if (this.querySelector('.collection-grid-video__poster')) {
        this.video.setAttribute('data-video-pending', '');
        this.video.addEventListener('playing', this.onPlaying);
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            this.play();
          } else {
            this.video.pause();
          }
        });
      }, { threshold: [0, 0.35] });
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.toggle && this.onToggle) this.toggle.removeEventListener('click', this.onToggle);
      if (this.video && this.onPlaying) this.video.removeEventListener('playing', this.onPlaying);
    }

    onPlaying() {
      this.video.removeAttribute('data-video-pending');
    }

    loadSource() {
      if (this.video.getAttribute('src')) return;
      const stream = this.video.dataset.streamSrc;
      if (stream && this.video.canPlayType('application/vnd.apple.mpegurl')) {
        this.video.src = stream;
      } else if (this.video.dataset.src) {
        this.video.src = this.video.dataset.src;
      }
    }

    play() {
      if (this.userPaused) return;
      this.loadSource();
      const playing = this.video.play();
      if (playing) playing.catch(() => {});
      this.updateToggle(false);
    }

    onToggle() {
      if (this.video.paused) {
        this.userPaused = false;
        this.play();
      } else {
        this.userPaused = true;
        this.video.pause();
        this.updateToggle(true);
      }
    }

    updateToggle(paused) {
      if (!this.toggle) return;
      const label = paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      if (label) this.toggle.setAttribute('aria-label', label);
    }
  }

  if (!customElements.get('collection-grid-video')) {
    customElements.define('collection-grid-video', CollectionGridVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["guarantee-stamp"] && !Shopify.designMode) return;
  try {
    class GuaranteeStamp extends HTMLElement {
    static storageKey = 'guarantee-stamp:minimized';
    static interval = 3500;
    static reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.badge = this.querySelector('[data-guarantee-stamp-badge]');
      this.facesContainer = this.querySelector('[data-guarantee-stamp-faces]');
      this.coin = this.querySelector('[data-guarantee-stamp-coin]');
      this.band = this.querySelector('[data-guarantee-stamp-band]');
      this.tab = this.querySelector('[data-guarantee-stamp-restore]');
      this.minimizeButton = this.querySelector('[data-guarantee-stamp-minimize]');
      this.opener = this.querySelector('[data-guarantee-stamp-open]');
      this.popup = document.getElementById(this.dataset.popup);
      if (!this.badge || !this.facesContainer) return;

      this.tabList = this.popup ? this.popup.querySelector('[data-guarantee-stamp-tabs]') : null;
      this.panelHost = this.popup ? this.popup.querySelector('[data-guarantee-stamp-panels]') : null;
      this.designMode = this.hasAttribute('data-design-mode');
      this.faces = [];
      this.tabs = [];
      this.activeIndex = 0;
      this.selectedTabIndex = 0;
      this.hovered = false;
      this.focused = false;
      this.minimized = false;
      this.selectedFace = null;
      this.flipping = false;
      this.flipToken = 0;

      this.onMinimize = () => this.setMinimized(true, true);
      this.onRestore = () => this.setMinimized(false, true);
      this.onOpen = () => {
        this.stopFlip();
        this.selectTabForFace(this.faces[this.activeIndex]);
      };
      this.onPointerEnter = () => (this.hovered = true);
      this.onPointerLeave = () => (this.hovered = false);
      this.onFocusIn = () => (this.focused = true);
      this.onFocusOut = () => (this.focused = false);
      this.onTabClick = (event) => {
        const button = event.target.closest('[role="tab"]');
        if (button) this.selectTab(this.tabs.indexOf(button));
      };
      this.onTabKeydown = (event) => this.handleTabKeydown(event);
      this.onSectionSelect = () => this.setMinimized(false, false);
      this.onBlockSelect = (event) => this.selectFace(event.target);
      this.onBlockDeselect = () => this.deselectFace();
      this.onSheenEnd = () => this.band.removeAttribute('data-sheen');

      if (this.minimizeButton) this.minimizeButton.addEventListener('click', this.onMinimize);
      if (this.tab) this.tab.addEventListener('click', this.onRestore);
      if (this.opener) this.opener.addEventListener('click', this.onOpen);
      if (this.tabList) {
        this.tabList.addEventListener('click', this.onTabClick);
        this.tabList.addEventListener('keydown', this.onTabKeydown);
      }
      this.badge.addEventListener('pointerenter', this.onPointerEnter);
      this.badge.addEventListener('pointerleave', this.onPointerLeave);
      this.badge.addEventListener('focusin', this.onFocusIn);
      this.badge.addEventListener('focusout', this.onFocusOut);
      if (this.band) this.band.addEventListener('animationend', this.onSheenEnd);

      this.section = this.closest('.shopify-section');
      if (this.section) {
        this.section.addEventListener('shopify:section:select', this.onSectionSelect);
        this.section.addEventListener('shopify:block:select', this.onBlockSelect);
        this.section.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.facesContainer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-tab-label'] });

      this.sync();
      if (this.minimizeButton && !this.designMode && this.readStoredMinimized()) this.setMinimized(true, false);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.stopFlip();
      if (this.observer) this.observer.disconnect();
      if (this.popup && this.popup.open) this.popup.open = false;
      if (!this.badge || !this.facesContainer) return;
      if (this.minimizeButton) this.minimizeButton.removeEventListener('click', this.onMinimize);
      if (this.tab) this.tab.removeEventListener('click', this.onRestore);
      if (this.opener) this.opener.removeEventListener('click', this.onOpen);
      if (this.tabList) {
        this.tabList.removeEventListener('click', this.onTabClick);
        this.tabList.removeEventListener('keydown', this.onTabKeydown);
      }
      this.badge.removeEventListener('pointerenter', this.onPointerEnter);
      this.badge.removeEventListener('pointerleave', this.onPointerLeave);
      this.badge.removeEventListener('focusin', this.onFocusIn);
      this.badge.removeEventListener('focusout', this.onFocusOut);
      if (this.band) this.band.removeEventListener('animationend', this.onSheenEnd);
      if (this.section) {
        this.section.removeEventListener('shopify:section:select', this.onSectionSelect);
        this.section.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.section.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    sync() {
      this.stopFlip();
      this.faces = Array.from(this.facesContainer.querySelectorAll('[data-guarantee-stamp-face]'));
      this.buildPopup();
      const selectedIndex = this.faces.indexOf(this.selectedFace);
      if (selectedIndex !== -1) this.activeIndex = selectedIndex;
      this.showFace(Math.min(this.activeIndex, Math.max(this.faces.length - 1, 0)));
      this.restartTimer();
    }

    buildPopup() {
      if (!this.tabList || !this.panelHost) return;
      const baseId = this.popup.id;
      this.tabList.replaceChildren();
      this.panelHost.replaceChildren();
      this.tabs = [];
      this.tabFaces = [];

      this.faces.forEach((face) => {
        const source = face.querySelector('[data-guarantee-stamp-panel]');
        if (!source) return;
        const index = this.tabs.length;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'guarantee-stamp-popup__tab';
        button.id = `${baseId}-tab-${index}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', `${baseId}-panel-${index}`);
        button.textContent = face.dataset.tabLabel || '';

        const panel = source.cloneNode(true);
        panel.removeAttribute('data-guarantee-stamp-panel');
        panel.id = `${baseId}-panel-${index}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;

        this.tabList.append(button);
        this.panelHost.append(panel);
        this.tabs.push(button);
        this.tabFaces.push(face);
      });

      this.tabList.hidden = this.tabs.length < 2;
      this.selectTab(Math.min(this.selectedTabIndex, Math.max(this.tabs.length - 1, 0)), false);
    }

    selectTab(index, moveFocus = false) {
      if (index < 0 || !this.tabs.length) return;
      this.selectedTabIndex = index;
      this.tabs.forEach((button, buttonIndex) => {
        const selected = buttonIndex === index;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (moveFocus) this.tabs[index].focus();
    }

    selectTabForFace(face) {
      const index = this.tabFaces ? this.tabFaces.indexOf(face) : -1;
      this.selectTab(index === -1 ? 0 : index);
    }

    handleTabKeydown(event) {
      const keys = { ArrowRight: 1, ArrowLeft: -1, Home: 'first', End: 'last' };
      if (!(event.key in keys) || !this.tabs.length) return;
      event.preventDefault();
      const step = keys[event.key];
      let index = this.selectedTabIndex;
      if (step === 'first') index = 0;
      else if (step === 'last') index = this.tabs.length - 1;
      else index = (index + step + this.tabs.length) % this.tabs.length;
      this.selectTab(index, true);
    }

    restartTimer() {
      window.clearInterval(this.timer);
      if (this.faces.length > 1) this.timer = window.setInterval(() => this.cycle(), GuaranteeStamp.interval);
    }

    cycle() {
      if (this.flipping || this.hovered || this.focused || this.minimized || this.selectedFace || document.hidden) return;
      if (this.popup && this.popup.open) return;
      const index = (this.activeIndex + 1) % this.faces.length;
      if (!this.coin || !this.coin.animate || GuaranteeStamp.reducedMotion.matches) {
        this.showFace(index);
        return;
      }
      this.flip(index);
    }

    async flip(index) {
      const coin = this.coin;
      const token = ++this.flipToken;
      this.flipping = true;
      coin.setAttribute('data-flipping', '');
      try {
        await coin.animate(
          [{ transform: 'perspective(420px) rotateY(0deg)' }, { transform: 'perspective(420px) rotateY(90deg)' }],
          { duration: 325, easing: 'cubic-bezier(0.55, 0, 1, 0.45)' }
        ).finished;
        if (token !== this.flipToken) return;
        this.showFace(index);
        await coin.animate(
          [{ transform: 'perspective(420px) rotateY(-90deg)' }, { transform: 'perspective(420px) rotateY(0deg)' }],
          { duration: 375, easing: 'cubic-bezier(0.2, 0.9, 0.3, 1.25)' }
        ).finished;
        if (token !== this.flipToken) return;
        this.playSheen();
      } catch (error) {
        return;
      } finally {
        if (token === this.flipToken) {
          this.flipping = false;
          coin.removeAttribute('data-flipping');
        }
      }
    }

    stopFlip() {
      this.flipToken += 1;
      this.flipping = false;
      if (!this.coin) return;
      this.coin.getAnimations().forEach((animation) => animation.cancel());
      this.coin.removeAttribute('data-flipping');
    }

    playSheen() {
      if (!this.band) return;
      this.band.removeAttribute('data-sheen');
      this.band.getBoundingClientRect();
      this.band.setAttribute('data-sheen', '');
    }

    showFace(index) {
      this.activeIndex = index;
      this.faces.forEach((face, faceIndex) => {
        face.toggleAttribute('data-active', faceIndex === index);
        face.toggleAttribute('data-inactive', faceIndex !== index);
      });
    }

    selectFace(target) {
      const face = target.closest ? target.closest('[data-guarantee-stamp-face]') : null;
      const index = this.faces.indexOf(face);
      if (index === -1) return;
      this.selectedFace = face;
      this.stopFlip();
      this.setMinimized(false, false);
      this.showFace(index);
      if (!this.popup || !this.tabFaces || this.tabFaces.indexOf(face) === -1) return;
      this.selectTabForFace(face);
      this.popup.open = true;
    }

    deselectFace() {
      if (this.popup && this.popup.open) this.popup.open = false;
      this.selectedFace = null;
    }

    setMinimized(value, moveFocus) {
      if (!this.minimizeButton || !this.tab) return;
      this.minimized = value;
      this.badge.hidden = value;
      this.tab.hidden = !value;
      this.toggleAttribute('data-minimized', value);
      if (!this.designMode) this.storeMinimized(value);
      if (moveFocus) (value ? this.tab : this.minimizeButton).focus();
    }

    readStoredMinimized() {
      try {
        return window.sessionStorage.getItem(GuaranteeStamp.storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    storeMinimized(value) {
      try {
        if (value) {
          window.sessionStorage.setItem(GuaranteeStamp.storageKey, 'true');
        } else {
          window.sessionStorage.removeItem(GuaranteeStamp.storageKey);
        }
      } catch (error) {
        return;
      }
    }
  }

  if (!customElements.get('guarantee-stamp')) customElements.define('guarantee-stamp', GuaranteeStamp);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["info-list"] && !Shopify.designMode) return;
  try {
    class UrlParamVisibility extends HTMLElement {
    connectedCallback() {
      const parameterName = this.dataset.parameterName;
      const condition = this.dataset.condition;
      if (!parameterName || condition === 'always') return;

      const hasParameter = new URLSearchParams(window.location.search).get(parameterName) !== null;
      let shouldShow = true;
      if (condition === 'matches') shouldShow = hasParameter;
      if (condition === 'does_not_match') shouldShow = !hasParameter;

      if (!shouldShow) {
        this.parentElement?.remove();
      }
    }
  }

  if (!customElements.get('url-param-visibility')) {
    customElements.define('url-param-visibility', UrlParamVisibility);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-offer"] && !Shopify.designMode) return;
  try {
    const BUNDLE_STEP_EASING = 'cubic-bezier(0.23, 1, 0.32, 1)';
  const BUNDLE_STEP_OFFSET = 36;
  const BUNDLE_STEP_DURATION = 380;
  const BUNDLE_MARKER_DURATION = 460;
  const BUNDLE_SPRING_EASING = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
  const BUNDLE_GALLERY_OFFSET = 57.6;
  const BUNDLE_FOOTER_DURATION = 300;
  const BUNDLE_LABEL_DURATION = 320;
  const BUNDLE_LABEL_DELAY = 80;
  const BUNDLE_CHECK_DURATION = 360;
  const BUNDLE_PROGRESS_DURATION = 500;
  const BUNDLE_GALLERY_FADE_DURATION = 260;
  const BUNDLE_BURST_PIECES = 18;
  const BUNDLE_DRAWER_REPLACEMENT_DELAY = 1600;
  const BUNDLE_COUNTDOWN_TICK = 1000;
  const BUNDLE_AUDIENCES = ['women', 'men', 'kids'];
  const BUNDLE_PREFETCH_MARGIN = '600px 0px';
  const BUNDLE_SWIPE_START = 6;
  const BUNDLE_SWIPE_CLOSE_DISTANCE = 110;
  const BUNDLE_SWIPE_CLOSE_VELOCITY = 0.6;
  const BUNDLE_SWIPE_DURATION = 220;

  class ProductBundleOffer extends HTMLElement {
    connectedCallback() {
      const configScript = this.querySelector('[data-bundle-config]');
      if (!configScript) return;

      this.config = JSON.parse(configScript.textContent);
      this.strings = this.decode(this.config.strings);
      this.isThreeForTwo = this.config.offer === 'three_for_two';
      this.pairCount = this.isThreeForTwo ? 3 : 2;
      this.percent = this.isThreeForTwo ? 100 : Number(this.config.percent) || 50;
      this.models = this.buildModels();
      this.form = document.getElementById(this.getAttribute('form-id'));
      this.switchButton = this.querySelector('[data-bundle-switch]');
      this.teaser = this.querySelector('[data-bundle-teaser]');
      this.checkIcon = this.querySelector('[data-bundle-check]')?.innerHTML || '';
      this.products = new Map();
      this.productRequests = new Map();
      this.state = null;
      this.activeSheet = null;

      this.onSwitchClick = this.onSwitchClick.bind(this);
      this.onOpenRequest = this.onOpenRequest.bind(this);
      this.onPageVariantChanged = this.onPageVariantChanged.bind(this);
      this.onSheetSubmit = this.onSheetSubmit.bind(this);
      this.onSheetClick = this.onSheetClick.bind(this);
      this.onSheetVariantChanged = this.onSheetVariantChanged.bind(this);
      this.onSheetClose = this.onSheetClose.bind(this);
      this.onSheetPointerDown = this.onSheetPointerDown.bind(this);
      this.onSwipeStart = this.onSwipeStart.bind(this);
      this.onSwipeMove = this.onSwipeMove.bind(this);
      this.onSwipeEnd = this.onSwipeEnd.bind(this);

      this.switchButton?.addEventListener('click', this.onSwitchClick);
      this.form?.addEventListener('variant:changed', this.onPageVariantChanged);
      document.addEventListener('bundle-offer:open', this.onOpenRequest);


      this.sheets = ['popover', 'drawer']
        .map((kind) => document.getElementById(`${this.config.sheetId}-${kind}`))
        .filter(Boolean);
      this.observers = this.sheets.map((sheet) => {
        sheet.addEventListener('submit', this.onSheetSubmit, true);
        sheet.addEventListener('click', this.onSheetClick);
        sheet.addEventListener('variant:changed', this.onSheetVariantChanged);
        sheet.addEventListener('openable-element:close', this.onSheetClose);
        sheet.addEventListener('pointerdown', this.onSheetPointerDown, { passive: true });
        if (sheet.tagName === 'QUICK-BUY-POPOVER') {
          sheet.addEventListener('touchstart', this.onSwipeStart, { passive: true });
          sheet.addEventListener('touchmove', this.onSwipeMove, { passive: false });
          sheet.addEventListener('touchend', this.onSwipeEnd);
          sheet.addEventListener('touchcancel', this.onSwipeEnd);
        }
        const observer = new MutationObserver(() => this.decorate(sheet));
        observer.observe(sheet, { childList: true });
        return observer;
      });

      this.freePairCode = this.config.freePair ? this.linkCode() : '';
      if (this.freePairCode) this.useFreePair();

      this.observePrefetch();
      this.startCountdown();
    }

    disconnectedCallback() {
      this.switchButton?.removeEventListener('click', this.onSwitchClick);
      this.form?.removeEventListener('variant:changed', this.onPageVariantChanged);
      document.removeEventListener('bundle-offer:open', this.onOpenRequest);
      if (this.onFormSubmit) document.removeEventListener('submit', this.onFormSubmit, true);
      this.pairCard?.removeEventListener('click', this.onPairCardClick);
      (this.sheets || []).forEach((sheet) => {
        sheet.removeEventListener('submit', this.onSheetSubmit, true);
        sheet.removeEventListener('click', this.onSheetClick);
        sheet.removeEventListener('variant:changed', this.onSheetVariantChanged);
        sheet.removeEventListener('openable-element:close', this.onSheetClose);
        sheet.removeEventListener('pointerdown', this.onSheetPointerDown);
        sheet.removeEventListener('touchstart', this.onSwipeStart);
        sheet.removeEventListener('touchmove', this.onSwipeMove);
        sheet.removeEventListener('touchend', this.onSwipeEnd);
        sheet.removeEventListener('touchcancel', this.onSwipeEnd);
      });
      (this.observers || []).forEach((observer) => observer.disconnect());
      this.prefetchObserver?.disconnect();
      clearInterval(this.countdownTimer);
    }

    observePrefetch() {
      const connection = navigator.connection;
      if (connection && (connection.saveData || /2g/.test(connection.effectiveType || ''))) return;
      this.prefetchObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.prefetchObserver.disconnect();
          const prefetch = () => {
            window.ThemeQuickBuy?.prefetch(this.quickBuyHref({ handle: this.config.handle }));
            this.loadProduct(this.config.handle);
          };
          if ('requestIdleCallback' in window) window.requestIdleCallback(prefetch, { timeout: 2000 });
          else setTimeout(prefetch, 200);
        },
        { rootMargin: BUNDLE_PREFETCH_MARGIN }
      );
      this.prefetchObserver.observe(this);
    }

    onSheetPointerDown(event) {
      const link = event.target.closest('.product-switcher a[href]');
      if (!link || event.currentTarget !== this.activeSheet) return;
      const url = new URL(link.href, window.location.href);
      url.searchParams.set('view', 'quick-buy');
      window.ThemeQuickBuy?.prefetch(`${url.pathname}${url.search}`);
    }

    swipePanel() {
      return this.activeSheet?.querySelector('.popover__content') || null;
    }

    onSwipeStart(event) {
      const panel = this.swipePanel();
      if (!this.state || event.currentTarget !== this.activeSheet || !panel || event.touches.length !== 1) return;
      if (!panel.contains(event.target)) return;
      const touch = event.touches[0];
      this.swipe = { panel, sheet: this.activeSheet, startX: touch.clientX, startY: touch.clientY, startTime: performance.now(), distance: 0, active: false };
    }

    onSwipeMove(event) {
      const swipe = this.swipe;
      if (!swipe) return;
      const touch = event.touches[0];
      const deltaY = touch.clientY - swipe.startY;
      const deltaX = touch.clientX - swipe.startX;
      if (!swipe.active) {
        if (Math.abs(deltaY) < BUNDLE_SWIPE_START && Math.abs(deltaX) < BUNDLE_SWIPE_START) return;
        if (deltaY <= 0 || Math.abs(deltaX) > Math.abs(deltaY) || swipe.panel.scrollTop > 0) {
          this.swipe = null;
          return;
        }
        swipe.active = true;
        swipe.sheet.style.transition = 'none';
      }
      event.preventDefault();
      swipe.distance = Math.max(0, deltaY);
      swipe.sheet.style.transform = `translateY(${swipe.distance}px)`;
    }

    onSwipeEnd() {
      const swipe = this.swipe;
      this.swipe = null;
      if (!swipe || !swipe.active) return;
      const velocity = swipe.distance / Math.max(1, performance.now() - swipe.startTime);
      const sheet = swipe.sheet;
      sheet.style.transition = `transform ${BUNDLE_SWIPE_DURATION}ms ${BUNDLE_STEP_EASING}`;
      if (swipe.distance > BUNDLE_SWIPE_CLOSE_DISTANCE || velocity > BUNDLE_SWIPE_CLOSE_VELOCITY) {
        sheet.style.transform = 'translateY(100%)';
        setTimeout(() => {
          sheet.open = false;
          sheet.style.transform = '';
          sheet.style.transition = '';
        }, BUNDLE_SWIPE_DURATION);
      } else {
        sheet.style.transform = '';
        setTimeout(() => {
          sheet.style.transition = '';
        }, BUNDLE_SWIPE_DURATION);
      }
    }

    decode(value) {
      if (typeof value === 'string') {
        this.decoder = this.decoder || document.createElement('textarea');
        this.decoder.innerHTML = value;
        return this.decoder.value;
      }
      if (Array.isArray(value)) return value.map((item) => this.decode(item));
      if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, this.decode(item)]));
      }
      return value;
    }

    buildModels() {
      const models =Array.isArray(this.config.models) ? this.config.models.filter((model) => model?.handle) : [];
      if (!models.length) return models;
      if (!models.some((model) => model.handle === this.config.page.handle)) models.unshift(this.config.page);
      return models;
    }

    startCountdown() {
      this.countdown = this.querySelector('[data-bundle-countdown]');
      if (!this.countdown) return;
      this.countdownEnd = new Date(this.countdown.dataset.end).getTime();
      if (!Number.isFinite(this.countdownEnd)) return;
      this.countdownPeriod = Number(this.countdown.dataset.repeatHours || 0) * 3600000;

      this.tickCountdown();
      if (!this.countdown.hidden) {
        this.countdownTimer = setInterval(() => this.tickCountdown(), BUNDLE_COUNTDOWN_TICK);
      }
    }

    tickCountdown() {
      const now = new Date();
      if (this.countdownPeriod > 0 && this.countdownEnd <= now.getTime()) {
        this.countdownEnd = this.nextCountdownEnd(now.getTime());
      }
      const remaining = Math.max(Math.floor((this.countdownEnd - now.getTime()) / 1000), 0);
      if (remaining <= 0 && !(this.countdownPeriod > 0)) {
        this.countdown.hidden = true;
        clearInterval(this.countdownTimer);
        return;
      }

      const pad = (value) => String(value).padStart(2, '0');
      const days = Math.floor(remaining / 86400);
      const clock = `${pad(Math.floor((remaining % 86400) / 3600))}:${pad(Math.floor((remaining % 3600) / 60))}:${pad(remaining % 60)}`;
      const time = days > 0 ? `${this.strings.daysShort.replace('[[days]]', days)} ${clock}` : clock;
      const endsToday = new Date(this.countdownEnd).toDateString() === now.toDateString();
      this.countdown.innerHTML = (endsToday ? this.strings.endsToday : this.strings.endsIn).replace('[[time]]', time);
      this.countdown.hidden = false;
    }

    nextCountdownEnd(nowTime) {
      const periodDays = this.countdownPeriod / 86400000;
      if (!Number.isInteger(periodDays)) {
        const elapsedPeriods = Math.floor((nowTime - this.countdownEnd) / this.countdownPeriod) + 1;
        return this.countdownEnd + elapsedPeriods * this.countdownPeriod;
      }
      const end = new Date(this.countdownEnd);
      const elapsedDays = Math.floor((nowTime - this.countdownEnd) / 86400000);
      end.setDate(end.getDate() + elapsedDays - (elapsedDays % periodDays));
      while (end.getTime() <= nowTime) end.setDate(end.getDate() + periodDays);
      return end.getTime();
    }

    linkCode() {
      const root = document.documentElement;
      if (root.hasAttribute('data-influencer')) return '';
      return (root.getAttribute('data-promo-code') || '').trim();
    }

    useFreePair() {
      this.percent = 100;
      this.config.discountCode = this.freePairCode;
      Object.assign(this.strings, {
        sheetTitle: this.strings.freePairSheetTitle,
        steps: this.strings.freePairSteps,
        next: this.strings.freePairNext,
        discount: this.strings.free,
      });
      this.sheets.forEach((sheet) => sheet.setAttribute('aria-label', this.strings.sheetTitle));

      this.pairCard = this.nextElementSibling?.matches('[data-bundle-pair]') ? this.nextElementSibling : null;
      this.onPairCardClick = (event) => {
        if (event.target.closest('[data-bundle-pair-open]')) this.open();
      };
      this.pairCard?.addEventListener('click', this.onPairCardClick);

      this.onFormSubmit = (event) => {
        if (!this.form || event.target !== this.form) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open();
      };
      document.addEventListener('submit', this.onFormSubmit, true);
    }

    renderPairCard(variant) {
      if (!this.pairCard || !variant) return;
      const price = this.money(variant.price);
      this.pairCard.querySelectorAll('[data-bundle-pair-price]').forEach((element) => {
        element.innerHTML = price;
      });
      const double = this.pairCard.querySelector('[data-bundle-pair-double]');
      if (double) double.innerHTML = this.money(variant.price * 2);
      const half = this.pairCard.querySelector('[data-bundle-pair-half]');
      if (half) half.innerHTML = this.strings.perPair.replace('[[amount]]', this.money(Math.round(variant.price / 2)));

      const parts = [this.config.page.name];
      if (this.config.colorIndex >= 0) parts.push(variant.options[this.config.colorIndex]);
      if (this.config.sizeIndex >= 0) parts.push(this.strings.sizeShort.replace('[[size]]', variant.options[this.config.sizeIndex]));
      const meta = this.pairCard.querySelector('[data-bundle-pair-meta]');
      if (meta) meta.textContent = parts.filter(Boolean).join(' \u00b7 ');

      const image = this.pairCard.querySelector('img');
      const source = variant.featured_image?.src;
      if (image && source) {
        const url = new URL(source.startsWith('//') ? `https:${source}` : source, window.location.href);
        url.searchParams.set('width', '144');
        image.src = url.toString();
        image.removeAttribute('srcset');
      }
    }

    money(cents) {
      return window.formatThemeMoney ? window.formatThemeMoney(cents) : (cents / 100).toFixed(2);
    }

    discountedPrice(price) {
      return price - Math.floor((price * this.percent) / 100);
    }

    discountIndex(pairs) {
      const prices = pairs.map((pair) => pair.price);
      return prices.lastIndexOf(Math.min(...prices));
    }

    totals(pairs) {
      const prices = pairs.map((pair) => pair.price);
      const discount = Math.floor((Math.min(...prices) * this.percent) / 100);
      const total = prices.reduce((sum, price) => sum + price, 0) - discount;
      const discountedIndex = discount > 0 ? this.discountIndex(pairs) : -1;
      const regular = pairs.reduce(
        (sum, pair, index) => sum + (index === discountedIndex ? pair.price : Math.max(pair.compare, pair.price)),
        0
      );
      return { total, regular, saving: regular - total, perPair: Math.round(total / pairs.length) };
    }

    onPageVariantChanged(event) {
      const variant = event.detail?.variant;
      this.renderPairCard(variant);
      if (!variant || !this.teaser || this.isThreeForTwo) return;
      this.teaser.innerHTML = this.strings.teaser.replace('[[amount]]', this.money(this.discountedPrice(variant.price)));
    }

    pageVariantId() {
      return this.form ? Number(new FormData(this.form).get('id')) || null : null;
    }

    productUrl(handle) {
      return `${window.themeVariables?.routes?.rootUrlWithoutSlash || ''}/products/${handle}`;
    }

    quickBuyHref(pair) {
      return `${this.productUrl(pair.handle)}?view=quick-buy`;
    }

    applyPairVariant(card) {
      const pair = this.state?.pairs[this.state.step - 1];
      const product = this.products.get(card.dataset.productHandle);
      if (!pair?.id || !product || pair.handle !== product.handle || !this.cardForm) return;
      if (Number(new FormData(this.cardForm).get('id')) === pair.id) return;
      const variant = product.variants.find((item) => item.id === pair.id);
      if (!variant) return;

      variant.options.forEach((value, index) => {
        const input = Array.from(card.querySelectorAll(`input[type="radio"][name="option${index + 1}"]`)).find(
          (candidate) => candidate.value === value
        );
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    pickSheet() {
      const phoneQuery = window.themeVariables?.breakpoints?.phone || 'screen and (max-width: 740px)';
      const tagName = window.matchMedia(phoneQuery).matches ? 'QUICK-BUY-POPOVER' : 'QUICK-BUY-DRAWER';
      return this.sheets.find((sheet) => sheet.tagName === tagName) || this.sheets[0];
    }

    onSwitchClick() {
      if (!this.activeSheet) this.burst();
      this.open();
    }

    burst() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const track = this.switchButton.querySelector('.product-bundle-offer__switch-track') || this.switchButton;
      const rect = track.getBoundingClientRect();
      const styles = getComputedStyle(this);
      const colors = ['--audience-accent', '--text-color', '--accent-men', '--accent-kids'].map(
        (name) => `rgb(${styles.getPropertyValue(name).trim()})`
      );
      for (let index = 0; index < BUNDLE_BURST_PIECES; index += 1) {
        const piece = document.createElement('span');
        const size = 4 + Math.random() * 4;
        const angle = Math.random() * Math.PI * 2;
        const distance = 36 + Math.random() * 54;
        piece.className = 'product-bundle-offer__burst';
        piece.style.cssText = `left:${rect.left + rect.width / 2}px;top:${rect.top + rect.height / 2}px;width:${size}px;height:${size}px;background:${colors[index % colors.length]};`;
        document.body.appendChild(piece);
        const flight = piece.animate(
          [
            { transform: 'translate(-50%, -50%) rotate(0deg)', opacity: 1 },
            {
              transform: `translate(calc(-50% + ${Math.cos(angle) * distance}px), calc(-50% + ${Math.sin(angle) * distance + 16}px)) rotate(${Math.random() * 540 - 270}deg)`,
              opacity: 0,
            },
          ],
          { duration: 620 + Math.random() * 280, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' }
        );
        flight.finished.then(() => piece.remove(), () => piece.remove());
      }
    }

    onOpenRequest(event) {
      this.open(event.detail?.pairs);
    }

    open(preset) {
      if (this.activeSheet) return;
      const sheet = this.pickSheet();
      if (!sheet) return;

      const presetPairs = (Array.isArray(preset) ? preset : [])
        .filter((pair) => pair?.handle)
        .map((pair) => ({ handle: pair.handle, id: Number(pair.id) || null }));
      const pairs =
        presetPairs.length === this.pairCount
          ? presetPairs
          : [{ handle: this.config.handle, id: this.pageVariantId() }, ...Array(this.pairCount - 1).fill(null)];

      this.state = { step: 1, maxStep: 1, direction: 0, progress: 0, shownStep: 0, pairs };
      this.activeSheet = sheet;
      this.switchButton.setAttribute('aria-expanded', 'true');
      this.showStep(1);
    }

    showStep(step) {
      const sheet = this.activeSheet;
      const href = this.quickBuyHref(this.state.pairs[step - 1]);
      this.state.direction = Math.sign(step - this.state.step);
      this.state.step = step;
      this.state.maxStep = Math.max(this.state.maxStep, step);
      sheet.dataset.bundleStep = String(step);
      sheet.toggleAttribute('data-bundle-last', step === this.pairCount);
      sheet.style.setProperty('--bundle-progress', String(step / this.pairCount));
      sheet.setAttribute('href', href);

      this.card = null;
      this.cardForm = null;
      sheet._loadedHref = null;
      const opened = () => {
        if (this.activeSheet === sheet && !sheet.open) sheet.open = true;
      };
      const failed = () => {
        if (this.activeSheet !== sheet) return;
        if (sheet.open) sheet.open = false;
        else this.reset();
      };
      sheet._load().then(opened, failed);
    }

    loadProduct(handle) {
      if (!this.productRequests.has(handle)) {
        const request = fetch(`${this.productUrl(handle)}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => {
            if (product) this.products.set(handle, product);
            else this.productRequests.delete(handle);
            return product;
          })
          .catch(() => {
            this.productRequests.delete(handle);
            return null;
          });
        this.productRequests.set(handle, request);
      }
      return this.productRequests.get(handle);
    }

    selection() {
      if (!this.card || !this.cardForm) return null;
      const product = this.products.get(this.card.dataset.productHandle);
      const id = Number(new FormData(this.cardForm).get('id'));
      const variant = product?.variants.find((item) => item.id === id);
      if (!variant) return null;

      return {
        handle: product.handle,
        id: variant.id,
        price: variant.price,
        compare: variant.compare_at_price || 0,
        available: variant.available,
      };
    }

    defaultPair(index) {
      const first = this.state.pairs[0];
      const product = this.products.get(first.handle);
      if (!product) return { handle: first.handle, id: first.id };

      const optionNames = product.options.map((option) => String(option.name || option).toLowerCase());
      const colorIndex = optionNames.findIndex((name) => this.config.colorLabels.includes(name));
      const sizeIndex = optionNames.findIndex((name) => this.config.sizeLabels.includes(name));
      const variantOf = (pair) => product.variants.find((variant) => variant.id === pair.id);
      const firstVariant = variantOf(first);
      const usedColors = new Set(
        this.state.pairs
          .slice(0, index)
          .filter((pair) => pair && pair.handle === product.handle)
          .map((pair) => (colorIndex < 0 ? null : variantOf(pair)?.options[colorIndex]))
      );
      const freshColor = (variant) => colorIndex < 0 || !usedColors.has(variant.options[colorIndex]);
      const sameSize = (variant) => sizeIndex < 0 || variant.options[sizeIndex] === firstVariant?.options[sizeIndex];
      const notPricier = (variant) => this.isThreeForTwo || variant.price <= first.price;
      const candidates = product.variants.filter((variant) => variant.available && freshColor(variant));
      const sameSizeCandidates = candidates.filter(sameSize);
      const match =
        sameSizeCandidates.find(notPricier) ||
        sameSizeCandidates[0] ||
        candidates.find(notPricier) ||
        candidates[0] ||
        firstVariant;

      return { handle: product.handle, id: match ? match.id : first.id };
    }

    decorate(sheet) {
      if (sheet !== this.activeSheet || !this.state) return;
      const card = sheet.querySelector('[data-quick-buy-product-card]');
      if (!card || card.hasAttribute('data-bundle-ready')) return;

      const form = card.querySelector('form[action*="/cart/add"]');
      const header = card.querySelector('.quick-buy-product-card__header');
      const productForm = card.querySelector('.product-form');
      if (!form || !header || !productForm) return;

      card.setAttribute('data-bundle-ready', '');
      this.card = card;
      this.cardForm = form;

      header.prepend(this.buildSteps());

      this.info = document.createElement('div');
      this.info.className = 'product-bundle-sheet__info';
      const name = document.createElement('p');
      name.className = 'product-bundle-sheet__name';
      name.textContent = this.familyName(card.querySelector('.quick-buy-product-card__title')?.textContent.trim() || '');
      const closeButton = card.querySelector('.quick-buy-product-card__close');
      closeButton?.setAttribute('aria-label', this.strings.close);
      closeButton?.setAttribute('title', this.strings.close);
      const price = document.createElement('p');
      price.className = 'product-bundle-sheet__price';
      this.info.append(name, price);
      (card.querySelector('.product-media-wrapper') || header).after(this.info);

      this.attachModelRows(card, productForm);
      this.footer = this.buildFooter(form);
      productForm.append(this.footer);
      this.attachSizeChartLink(card);

      this.render();
      this.loadProduct(card.dataset.productHandle).then((product) => {
        if (this.card !== card) return;
        if (!product) {
          this.showLoadError();
          return;
        }
        this.applyPairVariant(card);
        this.render();
      });
      this.animateStep(card);
    }

    showLoadError() {
      const message = document.createElement('p');
      message.className = 'product-bundle-sheet__error';
      message.setAttribute('role', 'alert');
      message.textContent = this.strings.error;
      this.footer.prepend(message);
    }

    familyName(title) {
      const audienceWords = ['women', 'men', 'kids', ...Object.values(this.strings.audiences || {}).map((label) => String(label).toLowerCase())];
      const words = title.split(/\s+/);
      while (words.length > 1 && audienceWords.includes(words[words.length - 1].toLowerCase())) words.pop();
      return words.join(' ');
    }

    attachModelRows(card, productForm) {
      if (!this.models.length) return;

      const handle = card.dataset.productHandle;
      const current = this.models.find((model) => model.handle === handle);
      const audience = current ? current.audience : this.config.audience;
      const audiences = BUNDLE_AUDIENCES.filter((value) => this.models.some((model) => model.audience === value));
      const sameAudience = this.models.filter((model) => model.audience === audience);

      const switcher = document.createElement('div');
      switcher.className = 'product-switcher product-bundle-sheet__switcher';

      if (audiences.length > 1) {
        const row = this.buildRow(this.strings.audienceLabel, 'link-switcher');
        audiences.forEach((value) => {
          const target = this.models.find((model) => model.audience === value);
          const option = this.buildOption(value === audience, target.url, 'link-switcher__option');
          option.textContent = this.strings.audiences[value] || value;
          if (value === audience) option.classList.add('link-switcher__option--static', 'active');
          row.lastElementChild.append(option);
        });
        switcher.append(row);
      }

      if (this.config.tiles && sameAudience.length > 1) {
        switcher.append(this.buildTileRow(sameAudience, handle));
        card.classList.add('product-bundle-sheet__card--tiles');
        this.attachColorStep(card);
      } else if (sameAudience.length > 1) {
        const row = this.buildRow(this.strings.modelLabel, 'product-bundle-sheet__models');
        sameAudience.forEach((model) => {
          const option = this.buildOption(model.handle === handle, model.url, 'product-bundle-sheet__model');
          if (model.image) {
            const image = document.createElement('img');
            image.src = model.image;
            image.alt = '';
            image.width = 48;
            image.height = 48;
            image.loading = 'lazy';
            option.append(image);
          }
          const label = document.createElement('span');
          label.textContent = model.name;
          option.append(label);
          row.lastElementChild.append(option);
        });
        switcher.append(row);
      }

      if (!switcher.children.length) return;
      card.classList.add('product-bundle-sheet__card--models');
      productForm.prepend(switcher);
    }

    buildStepTitle(number, label) {
      const title = document.createElement('p');
      title.className = 'product-bundle-sheet__step-title';
      const marker = document.createElement('span');
      marker.className = 'product-bundle-sheet__step-number';
      marker.textContent = String(number);
      title.append(marker, label);
      return title;
    }

    buildTileRow(models, handle) {
      const row = this.buildRow(this.strings.modelStep || this.strings.modelLabel, 'product-model-tiles');
      row.classList.add('product-switcher__row--models');
      if (this.strings.modelStep) row.prepend(this.buildStepTitle(1, this.strings.modelStep));
      models.forEach((model) => {
        const tile = this.buildOption(model.handle === handle, model.url, 'product-model-tiles__tile');
        const media = document.createElement('span');
        media.className = 'product-model-tiles__media';
        const source = model.tileImage || model.image;
        if (source) {
          const image = document.createElement('img');
          image.src = source;
          image.alt = '';
          image.width = 120;
          image.height = 120;
          image.loading = 'lazy';
          media.append(image);
        }
        const name = document.createElement('span');
        name.className = 'product-model-tiles__name';
        name.textContent = model.name;
        tile.append(media, name);
        if (model.colorsLabel) {
          const count = document.createElement('span');
          count.className = 'product-model-tiles__count';
          count.textContent = model.colorsLabel;
          tile.append(count);
        }
        row.lastElementChild.append(tile);
      });
      return row;
    }

    attachColorStep(card) {
      if (!this.strings.colorStep) return;
      const selector = card.querySelector('.product-form__option-selector[data-selector-type="variant-image"], .product-form__option-selector[data-selector-type="color"]');
      if (!selector || selector.querySelector('.product-bundle-sheet__step-title')) return;
      const title = this.buildStepTitle(2, this.strings.colorStep);
      const value = selector.querySelector('.product-form__option-value > span[id]');
      if (value) {
        value.classList.add('product-form__option-step-value');
        title.append(value);
      }
      selector.classList.add('product-form__option-selector--stepped');
      selector.prepend(title);
    }

    buildRow(label, listClass) {
      const row = document.createElement('div');
      row.className = 'product-switcher__row product-switcher__row--labeled';
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', label);
      const list = document.createElement('div');
      list.className = listClass;
      row.append(list);
      return row;
    }

    buildOption(isCurrent, url, className) {
      const option = document.createElement(isCurrent ? 'span' : 'a');
      option.className = className;
      if (isCurrent) option.setAttribute('aria-current', 'true');
      else option.href = url;
      return option;
    }

    attachSizeChartLink(card) {
      const chart = card.querySelector('.product-info-accordion:has(.size-chart)');
      const toggle = chart?.querySelector('.collapsible-toggle[aria-controls]');
      const sizeSelector = card.querySelector('.product-form__option-selector[data-selector-type="block"]');
      const sizeInfo = sizeSelector?.querySelector('.product-form__option-info');
      if (!chart || !toggle || !sizeInfo) return;

      const link = document.createElement('button');
      link.type = 'button';
      link.className = 'product-bundle-sheet__chart-link';
      link.textContent = toggle.textContent.trim();
      link.setAttribute('aria-controls', toggle.getAttribute('aria-controls'));
      link.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') || 'false');
      link.addEventListener('click', () => {
        toggle.click();
        const expanded = toggle.getAttribute('aria-expanded') || 'false';
        link.setAttribute('aria-expanded', expanded);
        if (expanded !== 'true') return;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        setTimeout(() => chart.scrollIntoView({ block: 'center', behavior }), 0);
      });

      sizeInfo.append(link);
      chart.classList.add('product-bundle-sheet__chart');
      sizeSelector.after(chart);
    }

    buildSteps() {
      const list = document.createElement('ol');
      list.className = `product-bundle-sheet__steps${this.pairCount > 2 ? ' product-bundle-sheet__steps--three' : ''}`;
      list.tabIndex = -1;
      list.setAttribute('aria-label', this.strings.sheetTitle);

      this.strings.steps.forEach((label, index) => {
        const number = index + 1;
        const status = number < this.state.step ? 'done' : number === this.state.step ? 'current' : 'todo';
        const item = document.createElement('li');
        item.className = `product-bundle-sheet__step product-bundle-sheet__step--${status}`;
        if (status === 'current') item.setAttribute('aria-current', 'step');

        const marker = document.createElement('span');
        marker.className = 'product-bundle-sheet__step-marker';
        marker.setAttribute('aria-hidden', 'true');
        if (status === 'done') marker.innerHTML = this.checkIcon;
        else marker.textContent = String(number);

        const text = document.createElement('span');
        text.className = 'product-bundle-sheet__step-label';
        text.textContent = label;

        if (status === 'done') {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-bundle-sheet__step-button';
          button.dataset.bundleGoStep = String(number);
          button.setAttribute('aria-label', this.strings.backToStep.replace('[[step]]', label));
          button.append(marker, text);
          item.append(button);
        } else {
          item.append(marker, text);
        }
        list.append(item);
      });

      return list;
    }

    buildFooter(form) {
      const footer = document.createElement('div');
      footer.className = 'product-bundle-sheet__footer';

      if (this.state.step < this.pairCount) {
        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'product-bundle-sheet__next';
        next.dataset.bundleNext = '';
        next.innerHTML = '<span data-bundle-next-label></span>';
        if (this.state.step === this.pairCount - 1) {
          const chip = document.createElement('em');
          chip.className = 'product-bundle-sheet__chip';
          chip.textContent = this.isThreeForTwo ? this.strings.offerChip : this.strings.discount;
          next.append(chip);
        }
        footer.append(next);
        return footer;
      }

      footer.innerHTML = `
        <div class="product-bundle-sheet__summary">
          <p class="product-bundle-sheet__total">
            <span><span data-bundle-pairs></span><s data-bundle-regular></s><b data-bundle-total></b></span>
            <small data-bundle-per-pair></small>
          </p>
          <span class="product-bundle-sheet__saving" data-bundle-saving></span>
        </div>
        <button type="button" class="product-bundle-sheet__back" data-bundle-back></button>
        <button type="submit" class="product-bundle-sheet__add" data-bundle-add>
          <span data-bundle-add-label></span><i class="product-bundle-sheet__dot" aria-hidden="true"></i><span data-bundle-add-total></span>
        </button>
        <p class="product-bundle-sheet__error" role="alert" hidden></p>`;
      footer.querySelector('[data-bundle-pairs]').textContent = this.strings.pairsTotal;
      footer.querySelector('[data-bundle-back]').textContent = this.strings.back;
      footer.querySelector('[data-bundle-add-label]').textContent = this.strings.add;
      footer.querySelector('[data-bundle-add]').setAttribute('form', form.getAttribute('id'));
      return footer;
    }

    render() {
      if (!this.card || !this.state) return;
      const current = this.selection();
      if (current) this.renderPrice(current);
      if (this.state.step < this.pairCount) this.renderNext(current);
      else this.renderSummary(current);
    }

    pairsWith(current) {
      const index = this.state.step - 1;
      return this.state.pairs.map((pair, position) => (position === index ? current : pair));
    }

    renderPrice(current) {
      const index = this.state.step - 1;
      const pairs = this.pairsWith(current);
      const allKnown = this.state.maxStep >= this.pairCount && pairs.every((pair) => pair && typeof pair.price === 'number');
      const isDiscounted = allKnown && this.discountIndex(pairs) === index;
      const isFree = isDiscounted && this.isThreeForTwo;
      const shown = isDiscounted ? this.discountedPrice(current.price) : current.price;
      const was = isDiscounted ? current.price : current.compare > current.price ? current.compare : 0;
      const price = this.info.querySelector('.product-bundle-sheet__price');
      const label = (text) => `<span class="visually-hidden">${text}</span>`;

      price.innerHTML =
        (was ? `<s class="product-bundle-sheet__was">${label(this.strings.regularPrice)}${this.money(was)}</s>` : '') +
        (isFree ? '' : `<span>${was ? label(this.strings.salePrice) : ''}${this.money(shown)}</span>`) +
        (isDiscounted ? '<em class="product-bundle-sheet__chip"></em>' : '');
      const chip = price.querySelector('em');
      if (chip) chip.textContent = isFree ? this.strings.free : this.strings.discount;
    }

    renderNext(current) {
      const next = this.footer.querySelector('[data-bundle-next]');
      const available = Boolean(current?.available);
      const label = this.state.step === 2 && this.pairCount > 2 ? this.strings.nextThird : this.strings.next;
      next.disabled = !available;
      next.querySelector('[data-bundle-next-label]').textContent = available || !current ? label : this.strings.soldOut;
    }

    renderSummary(current) {
      const add = this.footer.querySelector('[data-bundle-add]');
      add.disabled = !current?.available;
      add.querySelector('[data-bundle-add-label]').textContent = current && !current.available ? this.strings.soldOut : this.strings.add;
      const pairs = this.pairsWith(current);
      if (pairs.some((pair) => !pair || typeof pair.price !== 'number')) return;

      const totals = this.totals(pairs);
      this.footer.querySelector('[data-bundle-regular]').innerHTML = totals.saving > 0 ? this.money(totals.regular) : '';
      this.footer.querySelector('[data-bundle-total]').innerHTML = this.money(totals.total);
      this.footer.querySelector('[data-bundle-per-pair]').innerHTML = `${this.strings.perPair.replace('[[amount]]', this.money(totals.perPair))} \u00b7 ${this.strings.taxes}`;
      this.footer.querySelector('[data-bundle-saving]').innerHTML =
        totals.saving > 0
          ? this.strings.youSave.replace('[[amount]]', `<span class="product-bundle-sheet__saving-amount">${this.money(totals.saving)}</span>`)
          : '';
      this.footer.querySelector('[data-bundle-add-total]').innerHTML = this.money(totals.total);
    }

    animateStep(card) {
      const direction = this.state.direction;
      const sameStep = this.state.shownStep === this.state.step;
      const previousProgress = this.state.progress;
      const progress = this.state.step / this.pairCount;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.state.direction = 0;
      this.state.shownStep = this.state.step;
      this.state.progress = progress;
      this.galleryMediaId = null;

      const header = card.querySelector('.quick-buy-product-card__header');
      if (!reducedMotion && header && previousProgress !== progress) {
        header.animate([{ transform: `scaleX(${previousProgress})` }, { transform: `scaleX(${progress})` }], {
          duration: BUNDLE_PROGRESS_DURATION,
          easing: BUNDLE_STEP_EASING,
          pseudoElement: '::after',
        });
      }

      if (!direction) {
        if (sameStep && !reducedMotion) this.fadeGallery(card);
        return;
      }

      card.querySelector('.product-bundle-sheet__steps')?.focus({ preventScroll: true });
      if (reducedMotion) return;

      const slide = (element, distance) =>
        element?.animate(
          [
            { opacity: 0, transform: `translateX(${direction * distance}px)` },
            { opacity: 1, transform: 'none' },
          ],
          { duration: BUNDLE_STEP_DURATION, easing: BUNDLE_STEP_EASING }
        );
      slide(card.querySelector('.product-media-wrapper'), BUNDLE_GALLERY_OFFSET);
      slide(this.info, BUNDLE_STEP_OFFSET);
      Array.from(card.querySelector('.product-form')?.children || [])
        .filter((child) => child !== this.footer)
        .forEach((child) => slide(child, BUNDLE_STEP_OFFSET));
      this.footer?.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: BUNDLE_FOOTER_DURATION, easing: 'ease-out' });

      card.querySelector('.product-bundle-sheet__step--current .product-bundle-sheet__step-marker')?.animate(
        [{ transform: 'scale(0.5)' }, { transform: 'scale(1.25)', offset: 0.55 }, { transform: 'scale(1)' }],
        { duration: BUNDLE_MARKER_DURATION, easing: BUNDLE_SPRING_EASING }
      );
      card.querySelector('.product-bundle-sheet__step--current .product-bundle-sheet__step-label')?.animate(
        [
          { opacity: 0, transform: 'translateY(6px)' },
          { opacity: 1, transform: 'none' },
        ],
        { duration: BUNDLE_LABEL_DURATION, delay: BUNDLE_LABEL_DELAY, easing: BUNDLE_STEP_EASING, fill: 'backwards' }
      );
      if (direction > 0) {
        const doneMarkers = card.querySelectorAll('.product-bundle-sheet__step--done .product-bundle-sheet__step-marker');
        doneMarkers[doneMarkers.length - 1]?.animate([{ transform: 'scale(0.6)' }, { transform: 'scale(1)' }], {
          duration: BUNDLE_CHECK_DURATION,
          easing: BUNDLE_SPRING_EASING,
        });
      }
    }

    fadeGallery(card) {
      card?.querySelector('.product-media-wrapper')?.animate([{ opacity: 0.35 }, { opacity: 1 }], {
        duration: BUNDLE_GALLERY_FADE_DURATION,
        easing: BUNDLE_STEP_EASING,
      });
    }

    goNext() {
      const current = this.selection();
      if (!current?.available || this.state.step >= this.pairCount) return;
      const index = this.state.step - 1;
      this.state.pairs[index] = current;
      if (!this.state.pairs[index + 1]) this.state.pairs[index + 1] = this.defaultPair(index + 1);
      this.showStep(this.state.step + 1);
    }

    goToStep(step) {
      if (step < 1 || step === this.state.step) return;
      const current = this.selection();
      if (current) this.state.pairs[this.state.step - 1] = current;
      this.showStep(step);
    }

    onSheetClick(event) {
      if (!this.state || event.currentTarget !== this.activeSheet) return;
      const stepButton = event.target.closest('[data-bundle-go-step]');
      if (event.target.closest('[data-bundle-next]')) {
        this.goNext();
      } else if (event.target.closest('[data-bundle-back]')) {
        this.goToStep(this.state.step - 1);
      } else if (stepButton) {
        this.goToStep(Number(stepButton.dataset.bundleGoStep));
      }
    }

    onSheetVariantChanged(event) {
      if (event.currentTarget !== this.activeSheet) return;
      this.render();
      const mediaId = event.detail?.variant?.featured_media?.id;
      if (!mediaId) return;
      if (this.galleryMediaId && mediaId !== this.galleryMediaId && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.fadeGallery(this.card);
      }
      this.galleryMediaId = mediaId;
    }

    onSheetSubmit(event) {
      if (!this.state || event.currentTarget !== this.activeSheet) return;
      if (!event.target.closest('[data-quick-buy-product-card]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.state.step < this.pairCount) this.goNext();
      else this.addPairs(event.target);
    }

    async addPairs(form) {
      const current = this.selection();
      const pairs = this.pairsWith(current);
      const sheet = this.activeSheet;
      const button = this.footer.querySelector('[data-bundle-add]');
      const error = this.footer.querySelector('.product-bundle-sheet__error');
      if (!current?.available || pairs.some((pair) => !pair?.id) || button.getAttribute('aria-busy') === 'true') return;

      const routes = window.themeVariables.routes;
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;

      try {
        const response = await fetch(`${routes.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: pairs.map((pair) => ({ id: pair.id, quantity: 1 })),
            sections: ['mini-cart'],
          }),
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result) {
          throw new Error(response.status === 422 && result?.description ? result.description : this.strings.error);
        }

        const addedItems = result.items || [result];
        form.dispatchEvent(
          new CustomEvent('variant:added', {
            bubbles: true,
            detail: { variant: addedItems[addedItems.length - 1], items: addedItems },
          })
        );

        let cart = await (await fetch(`${routes.cartUrl}.js`)).json();
        let sections = result.sections;
        const discountSections = await this.applyDiscountCode(cart).catch(() => null);
        if (discountSections) {
          sections = discountSections;
          cart = await (await fetch(`${routes.cartUrl}.js`)).json();
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        cart.sections = sections;
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart,
              openMiniCart: window.themeVariables.settings.cartType === 'drawer',
              replacementDelay: sheet.tagName === 'QUICK-BUY-DRAWER' ? BUNDLE_DRAWER_REPLACEMENT_DELAY : 0,
            },
          })
        );
      } catch (addError) {
        error.textContent = addError instanceof TypeError ? this.strings.error : addError.message || this.strings.error;
        error.hidden = false;
      } finally {
        button.removeAttribute('aria-busy');
      }
    }

    async applyDiscountCode(cart) {
      const code = (this.config.discountCode || '').trim();
      if (!code) return null;
      const codes = (cart.discount_codes || []).map((entry) => entry.code).filter(Boolean);
      if (codes.some((existing) => existing.toLowerCase() === code.toLowerCase())) return null;

      const discount = [...codes, code].join(',');
      const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount, sections: ['mini-cart'] }),
      });
      if (!response.ok) return null;
      const updated = await response.json();
      document.dispatchEvent(new CustomEvent('discount:updated', { detail: { cart: updated, codes: discount } }));
      return updated.sections || null;
    }

    onSheetClose(event) {
      if (event.target === this.activeSheet) this.reset();
    }

    reset() {
      delete this.activeSheet.dataset.bundleStep;
      this.activeSheet.removeAttribute('data-bundle-last');
      this.activeSheet = null;
      this.state = null;
      this.card = null;
      this.cardForm = null;
      this.switchButton.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('product-bundle-offer')) customElements.define('product-bundle-offer', ProductBundleOffer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-creator"] && !Shopify.designMode) return;
  try {
    const CREATOR_VISIBILITY_THRESHOLD = 0.25;
  const CREATOR_EASING = 'cubic-bezier(0.23, 1, 0.32, 1)';
  const CREATOR_AMBIENT_INTERVAL = 90;
  const CREATOR_GRADIENT_SAMPLES = 30;
  const CREATOR_POSTER_WIDTH = 72;
  const CREATOR_DESKTOP_QUERY = 'screen and (min-width: 1000px)';
  const CREATOR_DRAG_START = 5;
  const CREATOR_DRAG_SWITCH = 40;
  const CREATOR_SHIFT_OPEN_DURATION = 620;
  const CREATOR_CURTAIN_DURATION = 620;
  const CREATOR_SHIFT_CLOSE_DURATION = 420;

  class ProductCreatorReel extends HTMLElement {
    static monotone(points) {
      const count = points.length;
      const xs = points.map((point) => point[0]);
      const ys = points.map((point) => point[1]);
      const slopes = [];
      const tangents = [];
      for (let index = 0; index < count - 1; index += 1) slopes.push((ys[index + 1] - ys[index]) / (xs[index + 1] - xs[index]));
      tangents[0] = 0;
      tangents[count - 1] = 0;
      for (let index = 1; index < count - 1; index += 1) {
        tangents[index] = slopes[index - 1] * slopes[index] <= 0 ? 0 : (slopes[index - 1] + slopes[index]) / 2;
      }
      for (let index = 0; index < count - 1; index += 1) {
        if (!slopes[index]) {
          tangents[index] = 0;
          tangents[index + 1] = 0;
          continue;
        }
        const alpha = tangents[index] / slopes[index];
        const beta = tangents[index + 1] / slopes[index];
        const length = alpha * alpha + beta * beta;
        if (length > 9) {
          const scale = 3 / Math.sqrt(length);
          tangents[index] = scale * alpha * slopes[index];
          tangents[index + 1] = scale * beta * slopes[index];
        }
      }
      return (x) => {
        if (x <= xs[0]) return ys[0];
        if (x >= xs[count - 1]) return ys[count - 1];
        let index = 0;
        while (x > xs[index + 1]) index += 1;
        const width = xs[index + 1] - xs[index];
        const t = (x - xs[index]) / width;
        const t2 = t * t;
        const t3 = t2 * t;
        return (
          (2 * t3 - 3 * t2 + 1) * ys[index] +
          (t3 - 2 * t2 + t) * width * tangents[index] +
          (3 * t2 - 2 * t3) * ys[index + 1] +
          (t3 - t2) * width * tangents[index + 1]
        );
      };
    }

    connectedCallback() {
      this.wrapper = this.closest('.product-media-wrapper');
      this.section = this.closest('.shopify-section') || document;
      this.track = this.querySelector('[data-creator-track]');
      this.stage = this.querySelector('.product-creator__stage');
      this.glow = this.querySelector('.product-creator__glow');
      this.cover = this.querySelector('.product-creator__layer--cover');
      this.night = this.querySelector('.product-creator__layer--night');
      this.deep = this.querySelector('.product-creator__layer--deep');
      this.soft = this.querySelector('.product-creator__layer--soft');
      this.ambientCanvas = this.querySelector('.product-creator__ambient');
      this.footer = this.querySelector('.product-creator__footer');
      this.prevArrow = this.querySelector('.product-creator__arrow--prev');
      this.nextArrow = this.querySelector('.product-creator__arrow--next');
      this.chip = this.wrapper ? this.wrapper.querySelector('[data-action="open-creator"]') : null;
      this.soundOn = false;
      this.isOpen = false;
      this.revealing = false;
      this.busy = false;
      this.inView = true;
      this.darkUntil = 0;
      this.activeIndex = -1;
      this.drag = null;
      this.posters = new Map();
      this.querySelectorAll('.product-creator__media video[poster]').forEach((video) => {
        video.parentElement.style.setProperty('--product-creator-poster', `url("${video.getAttribute('poster')}")`);
      });
      this.desktopQuery = window.matchMedia(CREATOR_DESKTOP_QUERY);

      this.onClick = this.onClick.bind(this);
      this.onChipClick = this.open.bind(this);
      this.onChipPointerDown = this.warmUp.bind(this);
      this.onTrackScroll = this.onTrackScroll.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerEnd = this.onPointerEnd.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.onTimeUpdate = this.onTimeUpdate.bind(this);
      this.onPlayState = this.onPlayState.bind(this);
      this.onPlaying = this.onPlaying.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onDesktopChange = this.onDesktopChange.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('timeupdate', this.onTimeUpdate, true);
      this.addEventListener('play', this.onPlayState, true);
      this.addEventListener('pause', this.onPlayState, true);
      this.addEventListener('playing', this.onPlaying, true);
      this.chip?.addEventListener('click', this.onChipClick);
      this.chip?.addEventListener('pointerdown', this.onChipPointerDown, { passive: true });
      this.track?.addEventListener('scroll', this.onTrackScroll, { passive: true });
      this.track?.addEventListener('pointerdown', this.onPointerDown);
      this.track?.addEventListener('pointermove', this.onPointerMove);
      this.track?.addEventListener('pointerup', this.onPointerEnd);
      this.track?.addEventListener('pointercancel', this.onPointerEnd);
      this.track?.addEventListener('dragstart', this.onDragStart);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.desktopQuery.addEventListener('change', this.onDesktopChange);

      this.observer = new IntersectionObserver(
        (entries) => {
          this.inView = entries[0].isIntersecting;
          if (!this.isOpen) return;
          if (this.inView) {
            this.playSelected();
            this.startAmbient();
          } else {
            this.pauseAll();
            this.stopAmbient();
          }
        },
        { threshold: CREATOR_VISIBILITY_THRESHOLD }
      );
      this.observer.observe(this);

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this);
      const info = this.section.querySelector('.product__info');
      if (info) this.resizeObserver.observe(info);
      document.fonts?.ready.then(() => this.fit());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('timeupdate', this.onTimeUpdate, true);
      this.removeEventListener('play', this.onPlayState, true);
      this.removeEventListener('pause', this.onPlayState, true);
      this.removeEventListener('playing', this.onPlaying, true);
      this.chip?.removeEventListener('click', this.onChipClick);
      this.chip?.removeEventListener('pointerdown', this.onChipPointerDown);
      this.track?.removeEventListener('scroll', this.onTrackScroll);
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointermove', this.onPointerMove);
      this.track?.removeEventListener('pointerup', this.onPointerEnd);
      this.track?.removeEventListener('pointercancel', this.onPointerEnd);
      this.track?.removeEventListener('dragstart', this.onDragStart);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.desktopQuery.removeEventListener('change', this.onDesktopChange);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.stopAmbient();
      cancelAnimationFrame(this.fitFrame);
      cancelAnimationFrame(this.stickyFrame);
      cancelAnimationFrame(this.scrollFrame);
      if (this.isOpen) this.setPageState(false);
    }

    get cards() {
      return Array.from(this.querySelectorAll('.product-creator__card'));
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    galleryParts() {
      if (!this.wrapper) return [];
      return [
        this.wrapper.querySelector('product-media'),
        this.wrapper.querySelector('.product__guarantee-badge--floating'),
      ].filter(Boolean);
    }

    setPageState(isLive) {
      const root = document.documentElement;
      root.toggleAttribute('data-product-creator', isLive);
      root.toggleAttribute('data-product-creator-ink', isLive);
      if (!isLive) root.removeAttribute('data-product-creator-sticky');
    }

    open() {
      if (this.isOpen || this.busy || this.desktopQuery.matches) return;
      this.isOpen = true;
      this.swap(() => this.show());
    }

    close() {
      if (!this.isOpen || this.busy) return;
      this.isOpen = false;
      document.documentElement.removeAttribute('data-product-creator-ink');
      this.swap(() => this.hide());
    }

    swap(change) {
      if (this.reducedMotion()) {
        change();
        return;
      }
      const outgoing = this.isOpen ? this.galleryParts() : [this];
      this.busy = true;
      const animations = outgoing.map((element) =>
        element.animate(
          [
            { opacity: 1, filter: 'blur(0)' },
            { opacity: 0, filter: 'blur(6px)' },
          ],
          { duration: 160, easing: CREATOR_EASING, fill: 'forwards' }
        )
      );
      Promise.all(animations.map((animation) => animation.finished.catch(() => null))).then(() => {
        change();
        animations.forEach((animation) => animation.cancel());
        if (!this.isOpen) {
          this.wrapper
            ?.querySelector('product-media')
            ?.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: CREATOR_EASING });
        }
        this.busy = false;
      });
    }

    show() {
      const info = this.section.querySelector('.product__info');
      const infoTop = info ? info.getBoundingClientRect().top : 0;
      this.revealing = !this.reducedMotion();
      this.hidden = false;
      this.wrapper?.classList.add('product-media-wrapper--creator');
      this.chip?.setAttribute('aria-expanded', 'true');
      this.setPageState(true);

      this.fit();
      if (this.activeIndex < 0) {
        this.go(0, true);
        this.setSelected(0);
      } else {
        this.go(this.activeIndex, true);
        this.playSelected();
      }
      this.startAmbient();
      this.querySelector('[data-action="close-creator"]')?.focus({ preventScroll: true });

      if (this.reducedMotion()) return;
      const offset = info ? infoTop - info.getBoundingClientRect().top : 0;
      if (info && Math.abs(offset) >= 1) {
        info.style.transform = `translateY(${offset}px)`;
        info.style.willChange = 'transform';
      }
      this.classList.add('product-creator--entering');
      requestAnimationFrame(() => requestAnimationFrame(() => this.animateIn(info, offset)));
    }

    animateIn(info, offset) {
      this.classList.add('product-creator--animating');
      this.classList.remove('product-creator--entering');
      if (info) info.style.transform = '';
      if (!this.isOpen) {
        this.classList.remove('product-creator--animating');
        if (info) info.style.willChange = '';
        return;
      }
      if (info && Math.abs(offset) >= 1) {
        info.animate([{ transform: `translateY(${offset}px)` }, { transform: 'none' }], {
          duration: CREATOR_SHIFT_OPEN_DURATION,
          easing: CREATOR_EASING,
        });
      }
      this.cover?.animate([{ transform: 'scaleY(1)' }, { transform: 'scaleY(0)' }], {
        duration: CREATOR_CURTAIN_DURATION,
        easing: CREATOR_EASING,
      });
      const stageReveal = this.stage?.animate(
        [
          { opacity: 0, filter: 'blur(14px)', transform: 'scale(1.05)' },
          { opacity: 1, filter: 'blur(0)', transform: 'none' },
        ],
        { duration: 700, delay: 60, easing: CREATOR_EASING, fill: 'backwards' }
      );
      const settle = () => {
        this.classList.remove('product-creator--animating');
        if (info) info.style.willChange = '';
        if (!this.revealing) return;
        this.revealing = false;
        this.playSelected();
        this.startAmbient();
      };
      if (stageReveal) stageReveal.finished.then(settle, settle);
      else settle();
      this.footer?.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 360,
        delay: 140,
        easing: CREATOR_EASING,
        fill: 'backwards',
      });
      this.cards.slice(Math.max(0, this.activeIndex - 1), this.activeIndex + 2).forEach((card, position) => {
        card.animate(
          [
            { opacity: 0, translate: '0 28px' },
            { opacity: card.classList.contains('is-selected') ? 1 : 0.42, translate: '0 0' },
          ],
          { duration: 600, delay: 120 + position * 80, easing: CREATOR_EASING, fill: 'backwards' }
        );
      });
    }

    hide() {
      const info = this.section.querySelector('.product__info');
      const infoTop = info ? info.getBoundingClientRect().top : 0;
      this.revealing = false;
      this.pauseAll();
      this.stopAmbient();
      this.hidden = true;
      this.wrapper?.classList.remove('product-media-wrapper--creator');
      this.chip?.setAttribute('aria-expanded', 'false');
      this.setPageState(false);
      this.chip?.focus({ preventScroll: true });

      const gallery = this.wrapper?.querySelector('product-media flickity-carousel');
      if (gallery && gallery.classList.contains('flickity-enabled')) {
        gallery.flickityInstance.then((flickity) => {
          if (flickity && flickity.isActive) flickity.resize();
        });
      }
      if (!this.reducedMotion()) this.shiftContent(info, infoTop, CREATOR_SHIFT_CLOSE_DURATION);

      const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const top = this.wrapper ? this.wrapper.getBoundingClientRect().top : 0;
      if (top < headerOffset) {
        window.scrollTo({ top: window.scrollY + top - headerOffset, behavior: this.reducedMotion() ? 'auto' : 'smooth' });
      }
    }

    shiftContent(element, previousTop, duration) {
      if (!element) return;
      const offset = previousTop - element.getBoundingClientRect().top;
      if (Math.abs(offset) < 1) return;
      element.animate([{ transform: `translateY(${offset}px)` }, { transform: 'none' }], { duration, easing: CREATOR_EASING });
    }

    centerIndex() {
      if (!this.track) return 0;
      const middle = this.track.scrollLeft + this.track.clientWidth / 2;
      let closest = 0;
      let closestDistance = Infinity;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - middle);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = index;
        }
      });
      return closest;
    }

    go(index, instant) {
      const cards = this.cards;
      const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
      if (!card || !this.track) return;
      this.track.scrollTo({
        left: card.offsetLeft + card.offsetWidth / 2 - this.track.clientWidth / 2,
        behavior: instant || this.reducedMotion() ? 'auto' : 'smooth',
      });
    }

    setSelected(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      this.cards.forEach((card, cardIndex) => card.classList.toggle('is-selected', cardIndex === index));
      this.syncArrows();
      this.syncCardFocus();
      this.playSelected();
    }

    onTrackScroll() {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.setSelected(this.centerIndex()));
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
      this.drag = { id: event.pointerId, x: event.clientX, scrollLeft: this.track.scrollLeft, moved: false };
    }

    onPointerMove(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(distance) < CREATOR_DRAG_START) return;
        drag.moved = true;
        this.track.classList.add('product-creator__track--dragging');
        this.track.setPointerCapture(drag.id);
      }
      this.track.scrollLeft = drag.scrollLeft - distance;
    }

    onPointerEnd() {
      const drag = this.drag;
      if (!drag) return;
      this.drag = null;
      this.track.classList.remove('product-creator__track--dragging');
      if (!drag.moved) return;
      const distance = this.track.scrollLeft - drag.scrollLeft;
      this.track.dataset.dragged = 'true';
      setTimeout(() => delete this.track.dataset.dragged, 0);
      const step = this.centerIndex() === this.activeIndex ? Math.sign(distance) : 0;
      this.go(Math.abs(distance) > CREATOR_DRAG_SWITCH ? this.activeIndex + step : this.activeIndex);
    }

    onDragStart(event) {
      event.preventDefault();
    }

    sampleGradient(points, end, format) {
      const curve = ProductCreatorReel.monotone(points);
      const start = points[0][0];
      return Array.from({ length: CREATOR_GRADIENT_SAMPLES + 1 }, (_, step) => {
        const y = start + ((end - start) * step) / CREATOR_GRADIENT_SAMPLES;
        return format(Math.max(0, Math.min(1, curve(y))), y);
      }).join(', ');
    }

    fit() {
      if (!this.isOpen || this.hidden || !this.night) return;

      const documentTop = (element) => {
        let top = 0;
        for (let node = element; node; node = node.offsetParent) top += node.offsetTop;
        return top;
      };
      const scope = this.section;
      const title = scope.querySelector('.product-meta__title');
      const price = scope.querySelector('.product-meta__price-and-countdown-timer');
      const chips = scope.querySelector('.product-form__highlights');
      const label = scope.querySelector('.product-form > .product-switcher .product-switcher__label');
      const colorInfo = scope.querySelector('.product-form__variants .product-form__option-info');

      const reelTop = documentTop(this);
      const reelBottom = reelTop + this.offsetHeight;
      const stageBottom = this.stage ? documentTop(this.stage) + this.stage.offsetHeight : reelBottom;
      const end = Math.max(reelBottom + 40, colorInfo ? documentTop(colorInfo) - 2 : reelBottom + 260);
      const titleTop = title ? documentTop(title) : reelBottom + 30;
      const priceBottom = price ? documentTop(price) + price.offsetHeight : titleTop + 40;
      const chipsTop = chips ? documentTop(chips) : priceBottom + 16;
      const chipsBottom = chips ? chipsTop + chips.offsetHeight : chipsTop + 60;
      const labelTop = label ? documentTop(label) : chipsBottom + 20;
      const labelBottom = label ? labelTop + label.offsetHeight : labelTop + 20;
      const tail = (share) => labelBottom + (end - labelBottom) * share;
      const clean = (points) =>
        points
          .filter((point, index) => point[0] < end || index === points.length - 1)
          .filter((point, index, list) => !index || point[0] > list[index - 1][0] + 1);

      const nightPoints = clean([
        [stageBottom - 20, 1],
        [reelBottom, 0.985],
        [titleTop, 0.95],
        [priceBottom, 0.88],
        [chipsTop, 0.8],
        [chipsBottom, 0.36],
        [labelTop, 0.2],
        [labelBottom, 0.12],
        [tail(0.35), 0.03],
        [tail(0.6), 0],
        [end, 0],
      ]);
      const deepPoints = clean([
        [chipsTop - 10, 1],
        [chipsBottom, 0.78],
        [labelTop, 0.52],
        [labelBottom, 0.34],
        [tail(0.45), 0.08],
        [tail(0.75), 0],
        [end, 0],
      ]);
      const softPoints = clean([
        [labelBottom, 1],
        [tail(0.3), 0.8],
        [tail(0.65), 0.34],
        [tail(0.88), 0.07],
        [end, 0],
      ]);

      const nightCurve = ProductCreatorReel.monotone(nightPoints);
      this.darkUntil = end;
      for (let step = 0; step <= 60; step += 1) {
        const y = nightPoints[0][0] + ((end - nightPoints[0][0]) * step) / 60;
        if (nightCurve(y) < 0.5) {
          this.darkUntil = y;
          break;
        }
      }

      const nightColor = getComputedStyle(this).getPropertyValue('--product-creator-night').trim() || '7, 7, 11';
      this.night.style.background = `linear-gradient(to bottom, rgb(${nightColor}) 0, ${this.sampleGradient(
        nightPoints,
        end,
        (alpha, y) => `rgba(${nightColor}, ${alpha.toFixed(3)}) ${y.toFixed(1)}px`
      )})`;
      [
        [this.deep, deepPoints],
        [this.soft, softPoints],
      ].forEach(([layer, points]) => {
        if (!layer) return;
        const mask = `linear-gradient(to bottom, rgb(0, 0, 0) 0, ${this.sampleGradient(
          points,
          end,
          (alpha, y) => `rgba(0, 0, 0, ${alpha.toFixed(3)}) ${y.toFixed(1)}px`
        )})`;
        layer.style.webkitMaskImage = mask;
        layer.style.maskImage = mask;
      });

      this.style.setProperty('--product-creator-top', `${reelTop}px`);
      this.style.setProperty('--product-creator-end', `${end}px`);
      this.style.setProperty('--product-creator-below', `${end - reelBottom}px`);
      this.syncSticky();
    }

    syncSticky() {
      this.stickyFrame = 0;
      const sticky = this.section.querySelector('product-sticky-form');
      const isDark = Boolean(
        this.isOpen && sticky && !sticky.hidden && this.darkUntil - window.scrollY > sticky.getBoundingClientRect().top
      );
      document.documentElement.toggleAttribute('data-product-creator-sticky', isDark);
    }

    onScroll() {
      if (!this.isOpen || this.stickyFrame) return;
      this.stickyFrame = requestAnimationFrame(() => this.syncSticky());
    }

    onResize() {
      if (!this.isOpen || this.fitFrame) return;
      this.fitFrame = requestAnimationFrame(() => {
        this.fitFrame = 0;
        this.fit();
      });
    }

    onDesktopChange(event) {
      if (!event.matches || !this.isOpen) return;
      this.isOpen = false;
      this.hide();
    }

    startAmbient() {
      if (this.ambientFrame || this.revealing || !this.isOpen || !this.inView || document.hidden || !this.ambientCanvas) return;
      if (this.reducedMotion()) return;
      this.ambientContext = this.ambientContext || this.ambientCanvas.getContext('2d');
      this.ambientTime = 0;
      const draw = (time) => {
        this.ambientFrame = requestAnimationFrame(draw);
        if (time - this.ambientTime < CREATOR_AMBIENT_INTERVAL) return;
        this.ambientTime = time;
        const video = this.selectedCard()?.querySelector('video');
        const source = video && video.readyState >= 2 ? video : this.posterFor(video);
        if (!source) return;
        this.ambientContext.globalAlpha = 0.22;
        this.ambientContext.drawImage(source, 0, 0, this.ambientCanvas.width, this.ambientCanvas.height);
      };
      this.ambientFrame = requestAnimationFrame(draw);
    }

    stopAmbient() {
      cancelAnimationFrame(this.ambientFrame);
      this.ambientFrame = 0;
    }

    posterFor(video) {
      const poster = video?.getAttribute('poster');
      if (!poster) return null;
      if (!this.posters.has(poster)) {
        this.posters.set(poster, null);
        const image = new Image();
        const url = new URL(poster, window.location.href);
        url.pathname = url.pathname.replace(/_\d+x(\.\w+)$/, '$1');
        url.searchParams.set('width', String(CREATOR_POSTER_WIDTH));
        image.src = url.toString();
        image.decode().then(() => createImageBitmap(image)).then(
          (bitmap) => this.posters.set(poster, bitmap),
          () => this.posters.delete(poster)
        );
      }
      return this.posters.get(poster);
    }

    warmUp() {
      const video = this.cards[Math.max(0, this.activeIndex)]?.querySelector('video');
      if (!video) return;
      this.posterFor(video);
      if (video.preload === 'none') video.preload = 'metadata';
    }

    onTimeUpdate(event) {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      const line = video.closest('.product-creator__media')?.querySelector('.product-creator__progress-line');
      if (line) line.style.width = `${video.duration ? (video.currentTime / video.duration) * 100 : 0}%`;
    }

    onPlaying(event) {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      const card = video.closest('.product-creator__card');
      if (!card || card.classList.contains('product-creator__card--playing')) return;
      const reveal = () => card.classList.add('product-creator__card--playing');
      if (typeof video.requestVideoFrameCallback === 'function') video.requestVideoFrameCallback(reveal);
      else reveal();
    }

    onPlayState(event) {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      const button = video.closest('.product-creator__media')?.querySelector('[data-action="toggle-play"]');
      if (button) button.setAttribute('aria-label', video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }

    onClick(event) {
      if (event.target.closest('[data-action="close-creator"]')) {
        this.close();
        return;
      }
      if (event.target.closest('[data-action="previous-clip"]')) {
        this.go(this.activeIndex - 1);
        return;
      }
      if (event.target.closest('[data-action="next-clip"]')) {
        this.go(this.activeIndex + 1);
        return;
      }
      if (this.track?.dataset.dragged) return;
      if (event.target.closest('[data-action="toggle-sound"]')) {
        this.toggleSound();
        return;
      }
      const card = event.target.closest('.product-creator__card');
      if (!card) return;
      if (!card.classList.contains('is-selected')) {
        this.go(this.cards.indexOf(card));
        return;
      }
      const video = card.querySelector('video');
      if (video && event.target.closest('.product-creator__media')) {
        if (video.paused) {
          const playback = video.play();
          if (playback) playback.catch(() => {});
        } else {
          video.pause();
        }
      }
    }

    toggleSound() {
      this.soundOn = !this.soundOn;
      this.querySelectorAll('[data-action="toggle-sound"]').forEach((button) => {
        button.setAttribute('aria-pressed', String(this.soundOn));
        button.setAttribute('aria-label', this.soundOn ? this.dataset.soundOffLabel : this.dataset.soundOnLabel);
      });
      this.playSelected();
    }

    selectedCard() {
      return this.querySelector('.product-creator__card.is-selected') || this.cards[0];
    }

    syncCardFocus() {
      const selected = this.selectedCard();
      this.cards.forEach((card) => {
        const tabIndex = card === selected ? 0 : -1;
        card.querySelectorAll('button').forEach((button) => {
          button.tabIndex = tabIndex;
        });
      });
    }

    syncArrows() {
      if (!this.prevArrow || !this.nextArrow) return;
      const cards = this.cards;
      const index = cards.indexOf(this.selectedCard());
      const atStart = index <= 0;
      const atEnd = index >= cards.length - 1;
      const focusedArrowHides =
        (atStart && document.activeElement === this.prevArrow) || (atEnd && document.activeElement === this.nextArrow);
      if (focusedArrowHides) (atStart ? this.nextArrow : this.prevArrow).focus({ preventScroll: true });
      this.prevArrow.disabled = atStart;
      this.nextArrow.disabled = atEnd;
    }

    playSelected() {
      if (!this.isOpen || this.revealing || document.hidden) return;
      const selected = this.selectedCard();
      const reducedMotion = this.reducedMotion();
      this.querySelectorAll('video').forEach((video) => {
        video.muted = !this.soundOn;
        if (selected && selected.contains(video) && !reducedMotion) {
          video.preload = 'auto';
          const playback = video.play();
          if (playback) playback.catch(() => {});
        } else {
          video.pause();
        }
      });
      const next = selected?.nextElementSibling?.querySelector('video');
      if (next && next.preload === 'none') next.preload = 'metadata';
    }

    pauseAll() {
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    onVisibilityChange() {
      if (!this.isOpen) return;
      if (document.hidden) {
        this.pauseAll();
        this.stopAmbient();
      } else {
        this.playSelected();
        this.startAmbient();
      }
    }
  }

  if (!window.customElements.get('product-creator-reel')) {
    window.customElements.define('product-creator-reel', ProductCreatorReel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["referral-code-toast"] && !Shopify.designMode) return;
  try {
    class ReferralToast extends HTMLElement {
    connectedCallback() {
      const urlParams = new URLSearchParams(location.search);
      this.referralCode = urlParams.get('referral_code');
      this.name = urlParams.get('name');
      this.messageElement = this.querySelector('.referral-toast__message');
      if (!this.referralCode || !this.messageElement) return;

      this.apply();
    }

    async apply() {
      try {
        const cart = await this.fetchCart();
        if (cart.attributes?.referral_code === this.referralCode) return;

        this.show('loading', this.dataset.textApplying);
        await new Promise((resolve) => setTimeout(resolve, 2000));

        const success = await this.updateCart(this.referralCode);
        const successMessage = this.name
          ? this.dataset.textSuccess.replace('{name}', this.name)
          : this.dataset.textSuccessNoName;
        this.show(success ? 'success' : 'error', success ? successMessage : this.dataset.textError);
        this.cleanupUrl();
      } catch (e) {
        console.error(e);
        this.show('error', this.dataset.textError);
      }
    }

    show(type, message) {
      this.classList.remove('is-loading', 'is-success', 'is-error', 'error');
      this.hidden = false;
      this.messageElement.textContent = message;

      if (type === 'loading') {
        this.classList.add('is-loading');
      } else if (type === 'success') {
        this.classList.add('is-success');
      } else {
        this.classList.add('is-error', 'error');
      }

      requestAnimationFrame(() => this.classList.add('show'));

      if (type !== 'loading') {
        setTimeout(() => this.hide(), 3000);
      }
    }

    hide() {
      this.classList.remove('show');
      setTimeout(() => {
        this.hidden = true;
      }, 250);
    }

    async fetchCart() {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    }

    async updateCart(code) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { referral_code: code } }),
      });
      return res.ok;
    }

    cleanupUrl() {
      const url = new URL(location.href);
      url.searchParams.delete('referral_code');
      url.searchParams.delete('name');
      history.replaceState({}, '', url);
    }
  }

  if (!customElements.get('referral-toast')) {
    customElements.define('referral-toast', ReferralToast);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart-table"] && !Shopify.designMode) return;
  try {
    class SizeChartTable extends HTMLElement {
    connectedCallback() {
      this.position = Number(this.dataset.sizePosition) || 0;
      if (!this.position) return;
      this.scope = this.closest('.product-form, [data-quick-buy-product-card]') || document;
      this.onVariantChanged = this.onVariantChanged.bind(this);
      this.scope.addEventListener('variant:changed', this.onVariantChanged);
    }

    disconnectedCallback() {
      this.scope?.removeEventListener('variant:changed', this.onVariantChanged);
    }

    onVariantChanged(event) {
      const variant = event.detail?.variant;
      if (!variant) return;
      const key = String(variant[`option${this.position}`] || '').replace(/\s+/g, '');
      this.querySelectorAll('tr[data-size]').forEach((row) => {
        const isSelected = row.dataset.size === key;
        row.classList.toggle('is-selected', isSelected);
        if (isSelected) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('size-chart-table')) customElements.define('size-chart-table', SizeChartTable);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-image-swatches"] && !Shopify.designMode) return;
  try {
    const VARIANT_SWATCH_ARROW_TILES = 3;

  class VariantSwatchSlider extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.variant-swatch-list');
      if (!this.list || this.list.hasAttribute('data-bundle-index')) return;
      this.arrows = Array.from(this.querySelectorAll('[data-swatch-arrow]'));
      this.onClick = this.onClick.bind(this);
      this.updateArrows = this.updateArrows.bind(this);
      this.addEventListener('click', this.onClick);
      this.list.addEventListener('scroll', this.updateArrows, { passive: true });
      this.resizeObserver = new ResizeObserver(this.updateArrows);
      this.resizeObserver.observe(this.list);

      const checkedSwatch = this.list.querySelector('.variant-swatch__radio:checked')?.closest('.variant-swatch');
      if (checkedSwatch) this.centerSwatch(checkedSwatch, 'instant');
      this.updateArrows();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.list?.removeEventListener('scroll', this.updateArrows);
      this.resizeObserver?.disconnect();
    }

    onClick(event) {
      const arrow = event.target.closest('[data-swatch-arrow]');
      if (arrow && this.contains(arrow)) {
        this.scrollByTiles(Number(arrow.dataset.swatchArrow));
        return;
      }
      const swatch = event.target.closest('.variant-swatch');
      if (swatch && this.list.contains(swatch)) this.centerSwatch(swatch, 'smooth');
    }

    scrollByTiles(direction) {
      const tile = this.list.querySelector('.variant-swatch');
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const amount = tile ? (tile.getBoundingClientRect().width + gap) * VARIANT_SWATCH_ARROW_TILES : this.list.clientWidth * 0.8;
      this.list.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    centerSwatch(swatch, behavior) {
      const listRect = this.list.getBoundingClientRect();
      const swatchRect = swatch.getBoundingClientRect();
      if (swatchRect.left >= listRect.left && swatchRect.right <= listRect.right) return;
      this.list.scrollBy({ left: swatchRect.left - listRect.left - listRect.width / 2 + swatchRect.width / 2, behavior });
    }

    updateArrows() {
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      const canPrev = maxScroll > 0 && this.list.scrollLeft > 0;
      const canNext = maxScroll > 0 && this.list.scrollLeft < maxScroll - 1;
      this.classList.toggle('swatch-container--can-prev', canPrev);
      this.classList.toggle('swatch-container--can-next', canNext);
      this.arrows.forEach((arrow) => {
        const isVisible = Number(arrow.dataset.swatchArrow) < 0 ? canPrev : canNext;
        arrow.style.display = isVisible ? 'block' : 'none';
      });
    }
  }

  if (!customElements.get('variant-swatch-slider')) customElements.define('variant-swatch-slider', VariantSwatchSlider);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-preview-popup"] && !Shopify.designMode) return;
  try {
    class VideoPreviewPopup {
    constructor(element) {
      this.element = element;
      this.modal = element.querySelector('[data-video-modal]');
      this.slides = this.buildSlides();
      this.currentIndex = 0;

      this.setupPreviewVideos();
      this.setupModal();
    }

    buildSlides() {
      const media = this.modal?.querySelector('[data-video-modal-media]');
      if (!media) return [];

      return Array.from(this.element.querySelectorAll('[data-video-modal-template]')).map((template, index) => {
        const slide = document.createElement('div');
        slide.className = 'video-preview-popup__slide';
        slide.hidden = index !== 0;
        slide.appendChild(template.content.cloneNode(true));
        media.appendChild(slide);
        return slide;
      });
    }

    setupPreviewVideos() {
      this.element.querySelectorAll('[data-preview-video]').forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.dataset.previewReady = 'false';

        const playPreview = () => {
          if (video.dataset.previewReady !== 'true') {
            return;
          }

          video.play().catch(() => {});
        };

        const keepPreviewShort = () => {
          if (video.currentTime >= 3) {
            video.currentTime = 0;
            playPreview();
          }
        };

        video.addEventListener('loadedmetadata', () => {
          if (!('IntersectionObserver' in window)) {
            video.dataset.previewReady = 'true';
          }

          playPreview();
        }, { once: true });

        video.addEventListener('timeupdate', keepPreviewShort);

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.dataset.previewReady = 'true';
                playPreview();
              } else {
                video.dataset.previewReady = 'false';
                video.pause();
              }
            });
          }, { rootMargin: '160px' });

          observer.observe(video);
        } else {
          video.dataset.previewReady = 'true';
        }

        if (video.readyState >= 1 && video.dataset.previewReady === 'true') {
          playPreview();
        }
      });
    }

    setupModal() {
      if (!this.modal || this.slides.length === 0) {
        return;
      }

      this.element.querySelectorAll('[data-video-trigger]').forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          this.open(index);
        });
      });

      this.modal.querySelector('[data-video-modal-close]')?.addEventListener('click', () => this.close());
      this.modal.querySelector('[data-video-modal-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
      this.modal.querySelector('[data-video-modal-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));

      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.close();
        }
      });

      this.modal.addEventListener('close', () => {
        this.pauseModalVideos();
      });

      this.modal.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          this.show(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          this.show(this.currentIndex + 1);
        }
      });
    }

    open(index) {
      this.show(index);

      if (this.modal.showModal) {
        this.modal.showModal();
      } else {
        this.modal.setAttribute('open', '');
      }

      this.playCurrentVideo();
    }

    close() {
      if (this.modal.close) {
        this.modal.close();
      } else {
        this.modal.removeAttribute('open');
        this.pauseModalVideos();
      }
    }

    show(index) {
      this.pauseModalVideos();
      this.currentIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== this.currentIndex;
      });

      if (this.modal.open) {
        this.playCurrentVideo();
      }
    }

    playCurrentVideo() {
      const video = this.slides[this.currentIndex]?.querySelector('[data-modal-video]');

      if (!video) {
        return;
      }

      video.muted = false;
      video.currentTime = 0;
      video.play().catch(() => {});
    }

    pauseModalVideos() {
      this.slides.forEach((slide) => {
        const video = slide.querySelector('[data-modal-video]');

        if (video) {
          video.pause();
        }
      });
    }
  }

  document.querySelectorAll('[data-video-preview-popup]').forEach((element) => {
    new VideoPreviewPopup(element);
  });
  } catch(e) { console.error(e); }
})();

})();
